"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var index_1 = require("../../../index");
function Language() {
    return (react_1.default.createElement(index_1.SettingContainer, null,
        react_1.default.createElement(index_1.DefaultTitle, null, "\u8BED\u8A00"),
        react_1.default.createElement(index_1.DesTitle, null, "\u9009\u62E9\u4E00\u79CD\u8BED\u8A00"),
        react_1.default.createElement(index_1.SettingRoundRadioButtonGroupView, { data: [
                {
                    language: "English",
                    country: "英语(英国)",
                    icon: "https://discordapp.com/assets/6bf3cf5d375d7561cb3b9bf74212ed45.png",
                },
                {
                    language: "中文",
                    country: "简体中文(中国)",
                    icon: "https://discordapp.com/assets/b2da62f020089ccee92860e4defafdb4.png",
                },
                {
                    language: "日本語",
                    country: "日语",
                    icon: "https://discordapp.com/assets/f23c5c28c4429691f7c54af93876d661.png",
                },
            ], onClick: function (item) {
                console.log(item);
            } })));
}
exports.Language = Language;
//# sourceMappingURL=Language.js.map